import { cardItems } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            热门黑料
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑部精选的深度好文，每篇都值得你花时间仔细阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-accent-500/90 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line text-sm"></i>
                    <span>{item.views.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}